<cc-box>
<!--  <div-->
<!--    class="lg-container"-->
<!--    header-->
<!--    box >{{'LEAD_GENERATION.SETTINGS.DISPLAY_CONDITIONS' | translate }}-->
<!--  </div>-->
  <div
    class="lg-container"
    header
    box >
    <span translate>LEAD_GENERATION.SETTINGS.DISPLAY_CONDITIONS</span>
    <ui-switch class="pull-right custom"
               (change)="changeDisplayConditionEnabling($event)"
               [(ngModel)]="leadGenerationConfig.displayConditionsEnabled">
    </ui-switch>
  </div>
  <div
    content
    box class="display-type-section">
<!--    <div class="lg-container">-->
<!--      <label translate>LEAD_GENERATION.SETTINGS.ENABLE_DISPLAY_CONDITIONS</label>-->
<!--      <ui-switch class="pull-right custom"-->
<!--        (change)="changeDisplayConditionEnabling($event)"-->
<!--        [(ngModel)]="leadGenerationConfig.displayConditionsEnabled">-->
<!--      </ui-switch>-->
<!--    </div>-->
    <form [formGroup]="displayConditionsFormWrapper.form" *ngIf="leadGenerationConfig.displayConditionsEnabled">
      <div class="lg-container b-t b-b p-x d-flex justify-content-space-between wrap">
        <label class="sm-down-p-t-sm" translate>CHOOSE</label>
        <mat-radio-group
          class="content d-flex sm-down-p-t-sm"
          layout-wrap
          formControlName="displayConditionsLogicalOperator"
          [(ngModel)]="leadGenerationConfig.displayConditionsLogicalOperator">
          <div class="radio-container m-r-3">
            <img
              src="../../../../assets/img/conditions_and.svg"
              [ngClass]="{ 'medium-grey-img': leadGenerationConfig.displayConditionsLogicalOperator !== 'and'}"
              alt="">
            <mat-radio-button
              value="and" >{{'AND' | translate}}
            </mat-radio-button>
          </div>
          <div class="radio-container">
            <img
              src="../../../../assets/img/conditions_or.png"
              [ngClass]="{ 'medium-grey-img': leadGenerationConfig.displayConditionsLogicalOperator !== 'or'}"
              alt="">
            <mat-radio-button
              value="or">{{'OR' | translate}}
            </mat-radio-button>
          </div>
        </mat-radio-group>
      </div>
      <div
        class="lg-container l-h-2 items">
        <div class="items-container">
          <label translate>LEAD_GENERATION.SETTINGS.DISPLAY_WHEN</label>
          <div>
            <div
              formArrayName="displayConditions"
              *ngFor="let itemForm of displayConditionsFormWrapper.form.get('displayConditions').controls; let first=first; let i = index;"
              class="item-container">
              <span
                *ngIf="first"
                class="primary-text text-lg">&#x2022;</span>
              <span
                *ngIf="!first"
                class="primary-text">{{this.displayConditionsFormWrapper.form.get('displayConditionsLogicalOperator').value }}</span>
              <cc-item [displayConditionForm]="itemForm"></cc-item>
              <div
                class="removalIcon"
                *ngIf="showRemovalIcon">
                <i
                  class="material-icons pointer"
                  (click)="deleteDisplayCondition(i)">delete</i>
              </div>
            </div>
          </div>
        </div>
        <div class="actions">
          <div>
            <a
              class="link pull-right"
              (click)="createNewDisplayCondition()">{{'LEAD_GENERATION.SETTINGS.ADD_CONDITION' | translate}} </a>
          </div>
        </div>
      </div>
    </form>
  </div>
</cc-box>
